module.exports = __webpack_public_path__ + "static/board-image-IE-e0cfea988680e7cec4caa3a815e30464.png";